import { graphql } from '#features/api';

/**
 * Narrow fragment used by the OG-image generator only.
 * Includes only fields Satori renders, skipping anything with an
 * auth-gated resolver (discordVoiceChannel, discordGuildName, favourite)
 * — OG handler runs anonymously on SSR, so a single @Current-required
 * resolver in the selection takes the whole query to 401.
 *
 * `@_unmask` flattens the fragment fields onto the parent so gql.tada's
 * generated type is plain-field, not a masked fragment handle — it also
 * avoids emitting `... on Post` InlineFragment which the backend's
 * RequestContextInjector ClassCasts to Field.
 */
export const postOgFragment = graphql(`
  fragment PostOgFragment on Post @_unmask {
    id
    text
    platformsIds
    mic
    updatedAt
    qr
    languages {
      code
      name
    }
    data {
      key
      previews
      socials
      values {
        id
        decorImage
        tagImage
        name
        unavailable
      }
    }
    gameData {
      id
      name
    }
    userData {
      avatar
      displayName
      birthday
      gender
      country {
        icon
        name
      }
      socials {
        id
        displayName
        type
        visible
      }
    }
    activeSession {
      startedAt
    }
  }
`);

export const postFragment = graphql(`
  fragment PostFragment on Post @_unmask {
    id
    userId
    text
    platformsIds
    adult
    mic
    commentsCount
    createdAt
    updatedAt
    bumpedAt
    gameId
    favourite
    qr
    discordGuildName

    # Во что играет автор - выбрано под игру и платформу ЭТОЙ заявки. У человека бывает сразу
    # несколько живых записей (Xbox на консоли, Steam на ПК), и выбрать нужную может только шлюз:
    # он видит заявку, все записи и настройки видимости. Поле собирает батч-лоадер, поэтому лента
    # любой длины стоит одного похода за активностью, а не одного на карточку.
    authorGameActivity {
      playingNow
      currentGameName
      currentSource
      gameId
      platform
      lastPlayedGameName
      lastPlayedSource
      lastPlayedAt
    }

    activeSession {
      id
      postId
      createdAt
      updatedAt
      startedAt
      expiredAt
      teamLimit
      status
      discordVoice
      voiceMode
      # Сколько человек в голосовом канале Discord: карточка считала только голос Teamplay, и
      # Discord-сессия с тремя людьми в канале выглядела пустой.
      discordVoiceCount
      voiceRoom {
        connectedCount
        maxParticipants
        status
        # кто именно сидит в комнате: карточка сессии показывает их лица и зовёт войти
        participants {
          userId
          connected
        }
      }
      sessionChat {
        id
        unreadCount
      }
      acceptedMembersCount
      members {
        memberId
        status
        userData {
          avatar
          displayName
          socials {
            id
            displayName
            type
            visible
          }
        }
      }
    }

    discordVoiceChannel {
      channelId
      postId
      published
      realtimeMembers {
        displayName
        avatarUrl
      }
    }

    languages {
      code
      name
      nativeName
    }

    data {
      key
      title
      viewType
      multiple
      pages
      previews
      socials

      values {
        id
        code
        badgeImage
        decorImage
        tagImage
        name
        unavailable
      }
    }

    gameData {
      id
      logo
      name
      platformsIds
    }

    userData {
      avatar
      displayName
      lastVisit
      id
      gender
      birthday

      socials {
        id
        displayName
        type
        visible
      }

      country {
        code
        icon
        name
      }
    }
  }
`);

export const recommendedPostFragment = graphql(`
  fragment RecommendedPostFragment on RecommendedPost @_unmask {
    id
    text
    platformsIds
    adult
    mic
    commentsCount
    createdAt
    updatedAt
    bumpedAt
    gameId
    favourite
    qr
    discordGuildName

    # Во что играет автор - выбрано под игру и платформу ЭТОЙ заявки. У человека бывает сразу
    # несколько живых записей (Xbox на консоли, Steam на ПК), и выбрать нужную может только шлюз:
    # он видит заявку, все записи и настройки видимости. Поле собирает батч-лоадер, поэтому лента
    # любой длины стоит одного похода за активностью, а не одного на карточку.
    authorGameActivity {
      playingNow
      currentGameName
      currentSource
      gameId
      platform
      lastPlayedGameName
      lastPlayedSource
      lastPlayedAt
    }

    activeSession {
      id
      postId
      createdAt
      updatedAt
      startedAt
      expiredAt
      teamLimit
      status
      discordVoice
      voiceMode
      discordVoiceCount
      voiceRoom {
        connectedCount
        maxParticipants
        status
      }
      sessionChat {
        id
        unreadCount
      }
      acceptedMembersCount
      members {
        memberId
        status
        userData {
          avatar
          displayName
          socials {
            id
            displayName
            type
            visible
          }
        }
      }
    }

    discordVoiceChannel {
      channelId
      postId
      published
      realtimeMembers {
        displayName
        avatarUrl
      }
    }

    languages {
      code
      name
      nativeName
    }

    data {
      key
      title
      viewType
      multiple
      pages
      previews
      socials

      values {
        id
        code
        badgeImage
        decorImage
        tagImage
        name
        unavailable
      }
    }

    gameData {
      id
      logo
      name
      platformsIds
    }

    userData {
      avatar
      displayName
      lastVisit
      id
      gender
      birthday

      socials {
        id
        displayName
        type
        visible
      }

      country {
        code
        icon
        name
      }
    }
  }
`);
